import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-time",
  "use": "app-icon-time-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-time\"><g fill=\"none\" fill-rule=\"evenodd\"><path fill=\"#FFF\" d=\"M0 0h16v16H0z\" /><path d=\"M8 0c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8 3.59-8 8-8zm0 1.5C4.42 1.5 1.5 4.42 1.5 8s2.92 6.5 6.5 6.5 6.5-2.92 6.5-6.5S11.58 1.5 8 1.5zm0 1.25c.41 0 .75.34.75.75v3.75h3.75c.41 0 .75.34.75.75s-.34.75-.75.75H8c-.41 0-.75-.34-.75-.75V3.5c0-.41.34-.75.75-.75z\" fill=\"#6C92FA\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol